export const PASSWORD_REQUIREMENTS = Object.freeze({
  minimumLength: 8,
  description: "Use pelo menos 8 caracteres, com uma letra maiúscula, uma minúscula e um número."
});

export class PasswordValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = "PasswordValidationError";
  }
}

export function validateNewPassword(value, label = "A senha") {
  const password = String(value || "");
  const missing = [];
  if (password.length < PASSWORD_REQUIREMENTS.minimumLength) missing.push("8 caracteres");
  if (!/\p{Lu}/u.test(password)) missing.push("uma letra maiúscula");
  if (!/\p{Ll}/u.test(password)) missing.push("uma letra minúscula");
  if (!/\d/u.test(password)) missing.push("um número");
  if (missing.length) {
    throw new PasswordValidationError(`${label} deve conter ${missing.join(", ")}.`);
  }
  return password;
}
